import React, { useState } from "react";
import "../styles/Login.css";
import { User, Lock, Unlock, Eye, EyeOff, ShieldCheck, LogIn } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  // Hardcoded credentials
  const correctUsername = "shubhjivan";
  const correctPassword = "Shubh@123";

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === correctUsername && password === correctPassword) {
      setError("");
      setShowPopup(true); // Show success popup
    } else {
      setError("Invalid username or password");
    }
  };

  const handlePopupClose = () => {
    setShowPopup(false);
    // Save login status in localStorage
    localStorage.setItem("isAuthenticated", "true");
    navigate("/admin/dashboard");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(to right, #E5DCFA 0%, #D3C5F8 100%)",
      }}
    >
      <div className="login-container mx-auto p-4 w-full max-w-xs relative">
        <h2 className="text-xl font-bold mb-4 flex items-center gap-2 justify-center">
          <ShieldCheck size={28} />
          Admin Login
        </h2>

        {error && (
          <p className="error text-red-500 mb-2 bg-red-100 p-2 rounded">
            {error}
          </p>
        )}
        <form onSubmit={handleLogin}>
          <div className="input-group relative mb-4">
            <label className="block mb-1">Username</label>
            <div className="flex items-center border rounded px-3 py-2">
              <User className="mr-2 text-gray-500" size={24} />
              <input
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="flex-1 outline-none"
              />
            </div>
          </div>
          <div className="input-group relative mb-4">
            <label className="block mb-1">Password</label>
            <div className="flex items-center border rounded px-3 py-2">
              {showPassword ? (
                <Unlock className="mr-2 text-gray-500" size={24} />
              ) : (
                <Lock className="mr-2 text-gray-500" size={24} />
              )}
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="flex-1 outline-none"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="ml-2 cursor-pointer"
              >
                {showPassword ? <EyeOff size={22} /> : <Eye size={22} />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="login-btn flex items-center gap-2 justify-center mx-auto bg-blue-500 text-white px-4 py-2 mt-4 rounded hover:bg-blue-600 transition-colors"
          >
            <LogIn size={20} />
            Login
          </button>
          <p className="text-center mt-2 text-gray-600">
            Only authorized admin can access this panel.
          </p>
        </form>

        {/* Success Popup */}
        {showPopup && (
  <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-30">
    <div className="bg-white/30 backdrop-blur-md p-6 rounded-xl shadow-lg animate-slide-down border border-white/20">
      <h3 className="text-2xl font-semibold mb-2 text-black">Login Successful</h3>
      <p className="mb-4 text-black-100">Welcome to the admin dashboard!</p>
      <button
        onClick={handlePopupClose}
        className="bg-gradient-to-r from-purple-500 to-indigo-500 text-white font-semibold px-4 py-2 rounded-full hover:from-indigo-500 hover:to-purple-500 transition-all duration-300 shadow-md"
      >
        OK
      </button>
    </div>
  </div>
)}

      </div>
    </div>
  );
};

export default AdminLogin;
